import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Product } from "../../domain/models/product-model";
import {
  LoadProductList,
  LoadProductListParams,
} from "../../domain/usecases/load-product-list";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadProductList implements LoadProductList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(params?: LoadProductListParams): Promise<Product[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: params,
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body || [];
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
